import React, { useContext } from "react";
import { LanguageContext } from "../../LanguageContext";
import { NavLink } from "react-router-dom";
import rudder from "../../assets/rudder.png";

const Navbar = () => {
  const { language, switchLanguage } = useContext(LanguageContext);

  const handleSwitch = () => {
    switchLanguage(language === "en" ? "es" : "en");
  };

  const handleMenuClick = () => {
    const menu = document.querySelector(".nav-ul");
    menu.classList.toggle("active");
    const menuDiv = document.querySelector(".menu-div");
    menuDiv.classList.toggle("rotate");
  };

  return (
    <header>
      <div className="container">
        <div className="wrap">
          <div className="flex-between">
            <button onClick={handleSwitch}>
              {language === "en" ? "EN" : "ES"}
            </button>
            <nav>
              <ul className="nav-ul">
                <li>
                  <NavLink
                    to="/"
                    end
                    className={({ isActive }) =>
                      isActive ? "active-link" : ""
                    }
                  >
                    Cabanyal
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/activities"
                    className={({ isActive }) =>
                      isActive ? "active-link" : ""
                    }
                  >
                    {language === "en"
                      ? "Discover Valencia"
                      : "Descubre Valencia"}
                  </NavLink>
                </li>
              </ul>
            </nav>
            <div className="menu-div" onClick={handleMenuClick}>
              <img src={rudder} alt="menu icon" />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
